import { render, staticRenderFns } from "./NotifyTarefas.vue?vue&type=template&id=ae086a1c&"
import script from "./NotifyTarefas.vue?vue&type=script&lang=js&"
export * from "./NotifyTarefas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports